import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DynamicPageBuilderNumericTextboxComponent } from './dynamic-page-builder-numeric-textbox.component';
import { MaterialModule } from 'src/app/shared/material.module';
import { PageBuilderNumericTextboxFormComponent } from './numeric-textbox-form/page-builder-numeric-textbox-form.component';

@NgModule({
    declarations: [
        PageBuilderNumericTextboxFormComponent, DynamicPageBuilderNumericTextboxComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ],
    entryComponents: [
        DynamicPageBuilderNumericTextboxComponent
    ]
})
export class PageBuilderNumericTextboxModule {}